import React from 'react';
import '/Users/jilin/projects/antd/rc-dialog/docs/changelog.md?watch=parent';
export const demos = {
};